import { Label } from '@cademy-ui/form';
import { FunctionComponent } from 'react';
import ReactHTML from '../../../ReactHTML';
import styles from './styles.module.scss';

export type CustomStatementFieldProps = {
    label: string;
    description?: string;
};

export const CustomStatementField: FunctionComponent<CustomStatementFieldProps> = ({
    label,
    description = '',
}) => {
    return (
        <div>
            <Label>{label}</Label>
            <div className={styles.statement}>
                <ReactHTML html={description} />
            </div>
        </div>
    );
};
